<div class="product-coupon-template-root">
  <div class="title">
    <app-header isBig title>{{ title }}</app-header>
  </div>
  <div class="instructions">
    <app-paragraph description
      >{{ label1 }} {{ coupon.rewardDescription }}<br /><br />
      {{ label2 }} <br /><br />
      {{ label3 }} 
    </app-paragraph>
  </div>
  <div class="coupon">
    <div #couponCard>
      <app-coupon-card
        coupon
        [rewardName]="coupon.rewardName!"
        [equipmentName]="coupon.productName"
        [businessName]="businessName"
        [rewardValue]="coupon.rewardDiscount!"
        [couponCode]="coupon.code!"
        [expirationDate]="coupon.expirationDate!"
        [couponStatus]="coupon.status!"
        [usedDate]="coupon.usedDate!"
        [countryName]="coupon.countryName"
        [equipmentSerial]="coupon.equipmentSerial"
      ></app-coupon-card>
      <div class="disclaimer-outter">
        <span *ngIf="hasDisclaimer" class="disclaimer-label">
          {{translatedStrings.disclaimer}}
        </span>
      </div>
    </div>
  </div>
  <div #buttons class="button-area">
    <div
      class="clickable-area"
      (click)="copy()"
      [title]="translatedStrings['copy-coupon-card-code']"
      id="copy-coupon-code"
    >
      <button mat-mini-fab color="">
        <mat-icon class="icon"> content_copy </mat-icon>
        <div
          #tooltip="matTooltip"
          matTooltip="{{ this.translatedStrings.codeCopied }}"
        ></div>
      </button>
      <app-label>{{ translatedStrings['copy-coupon-card-code'] }}</app-label>
    </div>
    <div (click)="downloadCoupon()" class="clickable-area" [title]="translatedStrings['download-coupon']" id="download-coupon">
      <button mat-mini-fab color="">
        <mat-icon class="icon"> download </mat-icon>
      </button>
      <app-label>{{ translatedStrings['download-coupon'] }}</app-label>
    </div>
    <div (click)="printCoupon()" class="clickable-area" [title]="translatedStrings.print" id="print-coupon">
      <button mat-mini-fab color="">
        <mat-icon class="icon"> print </mat-icon>
      </button>
      <app-label>{{ translatedStrings.print }}</app-label>
    </div>
  </div>
</div>
